import React from 'react';
import { useAuth } from '../../Common/Configurations/AuthContext';

const TemplateHeader1 = () => {
  const { user } = useAuth();
  const logoUrl = user?.logo || 'https://via.placeholder.com/150x40?text=Your+Logo';
  const navLinks = ['Home', 'Destinations', 'Packages', 'About Us', 'Reviews', 'Contact'];
  const styles = {
    header: {
      backgroundColor: 'var(--header-bg-color, #007bff)', // Use variable, fallback to blue
      padding: '1rem 2rem',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      
    },
    navLink: {
      color: 'var(--header-text-color, white)', 
    fontWeight: 600,
    }
  };

  return (
   <header className="navbar navbar-expand-lg" style={styles.header}>
      <a className="navbar-brand" href="#">
        <img src={logoUrl} alt="Company Logo" style={{ height: '40px', width: '60px' }} />
      </a>
      <div className="collapse navbar-collapse">
         <ul className="navbar-nav ms-auto gap-3 align-items-center">
          {/* Map directly to <li> elements */}
          {navLinks.map(link => (
            <li className="nav-item" key={link}>
              <a className="nav-link" href="#" style={styles.navLink}>{link}</a>
            </li>
          ))}
          {/* The "Book Now" button is just another list item */}
          <li className="nav-item ms-3">
            <a className="btn btn-light rounded-pill px-4 fw-bold" href="#">Book Now</a>
          </li>
        </ul>
      </div>
    </header>
  );
};

export default TemplateHeader1;